import { TelemetryEvent } from '../../utilities/insights/models/telemetry-event';

export class KeyboardShortcutEvent extends TelemetryEvent {
	constructor(shortcutAction: string) {
		super('keyboard-shortcut');
		this.context.action = shortcutAction;
	}
}



